import IconContainer from "./IconContainer"
import { IconProps } from "./IconUtilities"

const IconExit: React.FC<IconProps> = ({ className, size, contained }) => {
	if (contained) {
		return (
			<IconContainer
				className={className}
				size={size}
			>
				<path d="M9.09167 4.50833L7.91667 3.33333L3.75 7.5L7.91667 11.6667L9.09167 10.4917L6.94167 8.33333L15 8.33333L15 6.66667L6.94167 6.66667L9.09167 4.50833ZM1.66667 15L13.3333 15C14.2583 15 15 14.25 15 13.3333L15 10L13.3333 10L13.3333 13.3333L1.66667 13.3333L1.66667 1.66667L13.3333 1.66667L13.3333 5L15 5L15 1.66667C15 0.75 14.2583 -6.48386e-08 13.3333 -1.45705e-07L1.66667 -1.16564e-06C0.750001 -1.24577e-06 1.24577e-06 0.749999 1.16564e-06 1.66667L1.45705e-07 13.3333C6.55671e-08 14.25 0.75 15 1.66667 15Z" />
			</IconContainer>
		)
	}
	return (
		<path d="M9.09167 4.50833L7.91667 3.33333L3.75 7.5L7.91667 11.6667L9.09167 10.4917L6.94167 8.33333L15 8.33333L15 6.66667L6.94167 6.66667L9.09167 4.50833ZM1.66667 15L13.3333 15C14.2583 15 15 14.25 15 13.3333L15 10L13.3333 10L13.3333 13.3333L1.66667 13.3333L1.66667 1.66667L13.3333 1.66667L13.3333 5L15 5L15 1.66667C15 0.75 14.2583 -6.48386e-08 13.3333 -1.45705e-07L1.66667 -1.16564e-06C0.750001 -1.24577e-06 1.24577e-06 0.749999 1.16564e-06 1.66667L1.45705e-07 13.3333C6.55671e-08 14.25 0.75 15 1.66667 15Z" />
	)
}

export default IconExit
